export const SAVE_USER_DATA_START = 'SAVE_USER_DATA_START';
export const SAVE_USER_DATA_SUCCESS = 'SAVE_USER_DATA_SUCCESS';
export const SAVE_USER_DATA_FAILURE = 'SAVE_USER_DATA_FAILURE';
export const SAVE_USER_DATA_END = 'SAVE_USER_DATA_END';
export const CLEAR_SAVE_USER_DATA = 'CLEAR_SAVE_USER_DATA';
